import { CONNECTORS_WAGMI } from '@dapp/multi-lib/ui/wallet';
import { NetworkChainIds } from '@dapp/multi-lib/network';
import { createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { switchChain } from './chainSlice';
import { useSwitchChain } from 'wagmi';

export type SwitchChainPayload = NetworkChainIds;
export type SwitchChainAction = PayloadAction<SwitchChainPayload>;

export type SelectChainPayload = {
  newChainId: NetworkChainIds;
  connector?: CONNECTORS_WAGMI;
  currentChainId: NetworkChainIds;
};

export const selectChain = createAsyncThunk(
  'chain/selectChain',
  async (payload: SelectChainPayload, thunkApi) => {
    const { switchChain: switchChainWagmi } = useSwitchChain();
    const { newChainId, currentChainId } = payload as SelectChainPayload;

    if (newChainId === currentChainId) return;

    const dispatch = thunkApi.dispatch;

    if (typeof window !== 'undefined') {
      localStorage.setItem('SELECTED_NETWORK', newChainId.toString());
      switchChainWagmi({ chainId: newChainId });
      dispatch(switchChain(newChainId));
    }
  }
);
